import React, { useCallback, createContext, useEffect, useState } from "react";
import Posgrados from "./posgrados";
import DataCampus from "./campus";
import DataEscuelas from "./escuelas";
import DataNivel from "./nivelProgama";


import Programa from "./list";
import FiltroPrograma from "./filtro_programa";
import ProgramaCurso from "./ProgramaCurso";
//import CardCampus from "./card_campus";


export const GlobalStateContext = createContext();

function App() {
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$anahuacs-leadership/.test(string);
  const [item, setItem] = useState(Posgrados);
  const [idProgram, setidProgram] = useState(0);
  const [visibleCount, setVisibleCount] = useState(20);


  const [idCampus, setidCampus] = useState('all');
  const [idNivel, setidNivel] = useState('all');
  const [idFacultad, setidFacultad] = useState('all');

  const optionProgram = DataNivel;
  const optionFacultad = DataEscuelas;
  const optionCampus = DataCampus;


  const filtraUniversidad = useCallback((idCampus, idNivel, idFacultad) => {


    const dataFiltrada = Posgrados.filter((val) => {
      const matchCampus =
        idCampus === "all" ||
        val.campus_pro?.some(
          (campus) => String(campus.id_escuelas) === String(idCampus)
        );

      const matchNivel = idNivel === "all" || String(val.id_nivel) === String(idNivel);
      const matchFacultad = idFacultad === "all" || String(val.id_facultad) === String(idFacultad);

      return matchCampus && matchNivel && matchFacultad;
    });

    setItem(dataFiltrada);
    setidProgram(0);
    setVisibleCount(20);
  }, []);

useEffect(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id_programa");
    if (id && isNumeric(id)) {
      setidProgram(Number(id));
    }
},[])

  return (
    <GlobalStateContext.Provider
      value={{
        item,
        setItem,
        idProgram,
        setidProgram,
        idCampus,
        setidCampus,
        idNivel,
        setidNivel,
        idFacultad,
        setidFacultad,
           visibleCount, 
        setVisibleCount,
        filtraUniversidad
      }}
    >

      <div className="App">
 
            <FiltroPrograma
              fPosgrado={filtraUniversidad}
              setItem={setItem}
              DataNivel={optionProgram}
              DataCamp={optionCampus}
              DataFac={optionFacultad}
            />
       
        <div className="container">
          {idProgram !== 0 ? (
              <ProgramaCurso idProgram={idProgram} items={item} ></ProgramaCurso>
            ) : (
              <Programa setItem={setItem} item={item} />
            )}
        </div>
      </div>
    </GlobalStateContext.Provider>

  );
}

export default App;
